<script>
export default {
  props: ["data", "addClass"],
  data() {
    return {
      swiperOption: {
        speed: 1500,
        loop: true,
        // effect: 'slide',
        autoplay: {
          delay: 3000,
        },
        spaceBetween: 30,
        breakpoints: {
          1499: {
            slidesPerView: 3,
          },

          768: {
            slidesPerView: 1,
          },

          480: {
            slidesPerView: 1,
          },
        },
        navigation: {
          nextEl: ".ht-swiper-button-next",
          prevEl: ".ht-swiper-button-prev",
        },
      },
    };
  },
};
</script>
<template>
  <div
    class="section-testimonial brand-logo-slider-area section-space--inner--60"
    :class="addClass"
  >
    <div class="container mt-5 mb-5 position-relative">
      <div class="bg-home--testimonial"></div>
      <div class="row text-center mb-5">
        <div class="col-lg-12">
          <h3 class="text-color-default font-size-24">
            <span class="span-hr">TESTIMONI</span>
          </h3>
          <br />
          <h3>Apa Kata Mereka</h3>
          <!-- <p class="font-size-15">Testimoni dari SMA 1 Indonesia</p> -->
        </div>
      </div>
      <!-- brand logo slider -->
      <div class="brand-logo-slider__container-area">
        <div class="swiper-container brand-logo-slider__container">
          <div class="swiper-wrapper brand-logo-slider__wrapper">
            <swiper :options="swiperOption" v-if="data.length > 0">
              <div
                class="swiper-slide swiper-slide-testimonial brand-logo-slider__single justify-content-center"
                v-for="item in data"
                :key="item.id"
              >
                <div class="image text-center mt-3 mb-3">
                  <div class="col-sm-12">
                    <div class="row justify-content-center mb-4">
                      <div class="col-sm-12">
                        <a href="#">
                          <img
                            :src="item.image"
                            class="circular--landscape"
                            alt="brand logo"
                          />
                        </a>
                      </div>
                    </div>
                    <div class="row justify-content-center mb-3">
                      <div class="col-sm-8">
                        <p>"{{ item.body.substring(0, 150) }}"</p>
                      </div>
                    </div>
                    <div class="row justify-content-center">
                      <div class="col-sm-8">
                        <h3>{{ item.title }}</h3>
                        <p class="font-size-17 text-color-default">
                          {{ item.classOf }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper>
            <swiper :options="swiperOption" v-else>
              <div
                class="swiper-slide swiper-slide-testimonial brand-logo-slider__single justify-content-center"
              >
                <div class="image text-center mt-3 mb-3">
                  <div class="col-sm-12">
                    <div class="row justify-content-center mb-4">
                      <div class="col-sm-12">
                        <a href="#">
                          <img
                            src="@/assets/images/global/list_empty.png"
                            class="circular--landscape img-fluid h-100"
                            alt="brand logo"
                          />
                        </a>
                      </div>
                    </div>
                    <div class="row justify-content-center mb-3">
                      <div class="col-sm-8">
                        <p>Data belum tersedia</p>
                      </div>
                    </div>
                    <div class="row justify-content-center">
                      <div class="col-sm-8">
                        <h3>Data belum tersedia</h3>
                        <p class="font-size-17 text-color-default">
                          Data belum tersedia
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper>
            <div
              class="ht-swiper-button-prev ht-swiper-button-prev-13 ht-swiper-button-nav d-none d-xl-block"
            >
              <i class="ion-ios-arrow-left"></i>
            </div>
            <div
              class="ht-swiper-button-next ht-swiper-button-next-13 ht-swiper-button-nav d-none d-xl-block"
            >
              <i class="ion-ios-arrow-forward"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.testi-image {
  border-radius: 50%;
}
</style>
<style lang="scss" scoped>
@import "@/assets/scss/6-responsive/template-blue/index.scss";
</style>
